export const iconFontAwesomeSecurityBugSlash = (
	<i className="fa-solid fa-bug-slash"></i>
);
